<div class="if-dlg">

  <div class="if-dlg__head">
    <div class="if-dlg__head-left">
      <div class="if-dlg__icon"><mat-icon>home</mat-icon></div>
      <span class="if-dlg__title">Inversión Inmobiliaria</span>
      <mat-icon *ngIf="saved" class="if-dlg__saved">check_circle</mat-icon>
    </div>
    <button mat-icon-button (click)="closeDialog()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="if-dlg__body">

    <div class="if-import-banner" *ngIf="flagImport">
      Referencia: <strong>{{ movement.reference }}</strong> · Cuenta: {{ movement.accountNumber }}
    </div>

    <div class="if-layout if-layout--3" *ngIf="ready">

      <!-- Columna 1 — Datos básicos -->
      <div class="if-col">
        <div class="if-section">
          <div class="if-section__head">
            <mat-icon>info</mat-icon> Datos básicos
          </div>
          <div class="if-section__body">

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Proveedor</mat-label>
                <input matInput [(ngModel)]="investmentProperty.contactsName"
                  name="investmentProperty.contactsName"
                  [matAutocomplete]="auto" [formControl]="contactCtrl" required
                  matTooltip="Seleccione el contacto de la lista" [readonly]="readOnly" />
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option *ngFor="let contact of filteredContacts | async; trackBy: trackByIndex" [value]="contact.companyName">
                    {{ contact.companyName }}
                  </mat-option>
                </mat-autocomplete>
                <mat-icon matSuffix class="cf-spin-icon" *ngIf="(newContactLoaded | async) === false">autorenew</mat-icon>
              </mat-form-field>
              <app-help key='Inversion14'></app-help>
            </div>

            <div class="if-field">
              <app-autocomplete-select [items]="accounts"
                [(selectedItemId)]="investmentProperty.accountingModelsNumber"
                [idField]="'number'" [displayFields]="['number', 'name']" placeholder="Tipo inversión"
                (selectionChanged)="change($event)">
              </app-autocomplete-select>
              <app-help key='Inversion13'></app-help>
            </div>

            <app-input inputType="text" placeholder="Descripción" name="investmentProperty.investmentDescription"
              [isRequired]="true" [(ngModel)]="investmentProperty.investmentDescription"></app-input>

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Fecha de compra</mat-label>
              <input matInput [matDatepicker]="investmentDate" name="investmentProperty.investmentDate"
                [(ngModel)]="investmentProperty.investmentDate" required />
              <mat-datepicker-toggle matSuffix [for]="investmentDate"></mat-datepicker-toggle>
              <mat-datepicker #investmentDate></mat-datepicker>
            </mat-form-field>

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Uso</mat-label>
                <mat-select [(ngModel)]="investmentProperty.usage" name="usage">
                  <mat-option [value]="0" (click)="setUsageOption(0)">Sin seleccionar</mat-option>
                  <mat-option [value]="1" (click)="setUsageOption(1)">Desarrollo - Negocio</mat-option>
                  <mat-option [value]="2" (click)="setUsageOption(2)">Alquiler</mat-option>
                  <mat-option [value]="3" (click)="setUsageOption(3)">Propiedad</mat-option>
                  <mat-option [value]="4" (click)="setUsageOption(4)">Bien en especie</mat-option>
                </mat-select>
              </mat-form-field>
              <app-help key='Inversion15'></app-help>
            </div>

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Tipo amortización</mat-label>
              <input matInput value="Tabla AEAT" disabled />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Coeficiente lineal máximo</mat-label>
              <input matInput type="number" min="0" max="100"
                [(ngModel)]="investmentProperty.maximumLinearCoefficient"
                name="investmentProperty.maximumLinearCoefficient" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Periodo máximo (años)</mat-label>
              <input matInput type="number" min="0" max="100"
                [(ngModel)]="investmentProperty.maximumPeriod"
                name="investmentProperty.maximumPeriod" />
            </mat-form-field>

            <button mat-stroked-button (click)="newContact(true)"
              style="width:100%;border-radius:8px;margin-top:4px">
              <mat-icon>person_add</mat-icon> Nuevo contacto
            </button>
            <span *ngIf="(newContactLoaded | async) === null"
              style="font-size:12px;color:#dc2626;margin-top:4px;display:block">
              No se pudo obtener la lista de contactos
            </span>

          </div>
        </div>
      </div>

      <!-- Columna 2 — Valores e importes -->
      <div class="if-col">
        <div class="if-section">
          <div class="if-section__head">
            <mat-icon>domain</mat-icon> Valores catastrales
          </div>
          <div class="if-section__body">

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Valor compra construcción</mat-label>
                <input matInput [(ngModel)]="investmentProperty.purchaseValueConstruction"
                  name="investmentProperty.purchaseValueConstruction" />
              </mat-form-field>
              <app-help key='Inversion17'></app-help>
            </div>

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Valor de compra suelo</mat-label>
                <input matInput [(ngModel)]="investmentProperty.landPurchaseValue"
                  name="investmentProperty.landPurchaseValue" />
              </mat-form-field>
              <app-help key='Inversion18'></app-help>
            </div>

            <app-input inputType="text" placeholder="Referencia catastral" name="investmentProperty.cadastralReference"
              [(ngModel)]="investmentProperty.cadastralReference"></app-input>

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Valor catastral</mat-label>
                <input matInput [(ngModel)]="investmentProperty.cadastralValue"
                  name="investmentProperty.cadastralValue" />
              </mat-form-field>
              <app-help key='Inversion19'></app-help>
            </div>

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Valor catastral construcción</mat-label>
                <input matInput [(ngModel)]="investmentProperty.cadastralValueConstruction"
                  name="investmentProperty.cadastralValueConstruction" />
              </mat-form-field>
              <app-help key='Inversion16'></app-help>
            </div>

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Valor catastral suelo</mat-label>
                <input matInput [(ngModel)]="investmentProperty.cadastralValueLand"
                  name="investmentProperty.cadastralValueLand" />
              </mat-form-field>
              <app-help key='Inversion20'></app-help>
            </div>

            <div class="if-field">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Valor residual</mat-label>
                <input matInput min="0" [(ngModel)]="investmentProperty.residualValue"
                  name="investmentProperty.residualValue" />
              </mat-form-field>
              <app-help key='Inversion21'></app-help>
            </div>

          </div>
        </div>

        <div class="if-section">
          <div class="if-section__head">
            <mat-icon>receipt</mat-icon> Importes e impuestos
          </div>
          <div class="if-section__body">

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Total (sin impuestos)</mat-label>
              <input matInput type="text" [(ngModel)]="investmentProperty.base"
                name="investmentProperty.base" required />
            </mat-form-field>

            <app-autocomplete-select [items]="taxes" [idField]="'id'" [displayField]="'name'"
              placeholder="Impuestos" (selectionChanged)="onSelectTax($event)">
            </app-autocomplete-select>

            <convfact-chips-component [chipsElements]="investmentProperty.taxes" [container]="this"
              [changeFunction]="changeChips">
            </convfact-chips-component>

            <p class="if-total">Total: <span>{{ calcularTotal() }}</span></p>

            <mat-slide-toggle (change)="changeToggleCompanyPremisesOrOffice($event)"
              [checked]="investmentProperty.companyPremisesOrOffice" name="companyPremisesOrOffice">
              Local / oficina empresa
            </mat-slide-toggle>

          </div>
        </div>
      </div>

      <!-- Columna 3 — Documento -->
      <div class="if-col">
        <div class="if-section">
          <div class="if-section__head">
            <mat-icon>attach_file</mat-icon> Documento adjunto
          </div>
          <div class="if-section__body">
            <div class="if-file-area">
              <app-add-file [originEntity]="originEntity" [filePath]="filePath" [imageTempUrl]="imageTempUrl"
                (CallbackParameters)="SetFileParameters($event)">
              </app-add-file>
              <ng-container *ngIf="readyLoadedFiles === false">
                <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
              </ng-container>
              <div class="if-file-preview" *ngIf="imageTempUrl != null">
                <div class="imageFile" *ngIf="investmentProperty.isImage">
                  <app-image-zoom [src]="imageTempUrl"></app-image-zoom>
                </div>
                <div class="pdf-container" *ngIf="investmentProperty.isPdf">
                  <ngx-extended-pdf-viewer [src]="imageTempUrl" [useBrowserLocale]="true"
                    [height]="'70%'" [textLayer]="false">
                  </ngx-extended-pdf-viewer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="if-dlg__foot">
    <button mat-stroked-button class="if-btn-cancel" (click)="closeDialog()">Cancelar</button>
    <button mat-flat-button class="if-btn-save" (click)="save()">
      <mat-icon>save</mat-icon> Guardar
    </button>
  </div>

</div>
